import React, { useEffect, useState, useRef } from "react";
import { useRefinementList, useClearRefinements } from "react-instantsearch";

export const CustomRefinementList = ({
                                         attribute,
                                         exclusions = [],
                                         onExclude,
                                         cachedItems = [],
                                         onCacheUpdate,
                                     }) => {
    const [mode, setMode] = useState('inclure');
    const [search, setSearch] = useState('');
    const isFrozen = useRef(false);

    const { items, refine } = useRefinementList({
        attribute,
        limit: 20,
        showMore: false,
    });

    const { refine: clearAll } = useClearRefinements({
        includedAttributes: [attribute],
    });

    useEffect(() => {
        if (!isFrozen.current && items.length > 0) {
            onCacheUpdate(attribute, items);
        }
    }, [items, attribute, onCacheUpdate]);

    const displayedItems = (cachedItems.length > 0 ? cachedItems : items).map(cachedItem => {
        const liveItem = items.find(i => i.value === cachedItem.value);
        return {
            ...cachedItem,
            isRefined: liveItem ? liveItem.isRefined : false,
        };
    });

    const filteredItems = search.trim()
        ? displayedItems.filter(item => {
            const label = Array.isArray(item.label) ? item.label.join('/') : item.label;
            return label.toLowerCase().includes(search.toLowerCase());
        })
        : displayedItems;

    const handleModeChange = (newMode) => {
        clearAll();
        onExclude([]);
        isFrozen.current = false;
        setMode(newMode);

        // Si on sélectionne "n'appartient pas" → exclure tous les items immédiatement
        if (newMode === 'nappartient_pas') {
            const allValues = displayedItems.map(i => i.value);
            isFrozen.current = true;
            onExclude(allValues);
        }
    };

    const handleCheck = (item) => {
        if (mode === 'inclure') {
            refine(item.value);

        } else if (mode === 'exclure') {
            const updated = exclusions.includes(item.value)
                ? exclusions.filter(v => v !== item.value)
                : [...exclusions, item.value];
            isFrozen.current = updated.length > 0;
            onExclude(updated);

        } else if (mode === 'nappartient_pas') {
            // Coche = exclure tous les AUTRES
            const allOtherValues = displayedItems
                .filter(i => i.value !== item.value)
                .map(i => i.value);
            const alreadyExcludingOthers = allOtherValues.every(v => exclusions.includes(v));
            if (alreadyExcludingOthers) {
                // Décocher = tout remettre à zéro
                isFrozen.current = false;
                onExclude([]);
            } else {
                isFrozen.current = true;
                onExclude(allOtherValues);
            }
        }
    };

    const isChecked = (item) => {
        if (mode === 'inclure') return item.isRefined;
        if (mode === 'exclure') return exclusions.includes(item.value);
        if (mode === 'nappartient_pas') return true; // tout coché = tout barré
        return false;
    };

    const hasActiveFilter = displayedItems.some(i => i.isRefined) || exclusions.length > 0;

    const handleClearAll = () => {
        isFrozen.current = false;
        clearAll();
        onExclude([]);
        setMode('inclure');
        setSearch('');
    };

    return (
        <div className="crl-panel">

            {/* Select mode global */}
            <select
                className={`crl-select crl-select--${mode}`}
                value={mode}
                onChange={e => handleModeChange(e.target.value)}
            >
                <option value="inclure">Inclure</option>
                <option value="exclure">Exclure</option>
                <option value="nappartient_pas">N'appartient pas</option>
            </select>

            {/* Recherche */}
            <div className="crl-search-wrap">
                <svg className="crl-search-icon" width="13" height="13" viewBox="0 0 20 20"
                     fill="none" stroke="currentColor" strokeWidth="2.2">
                    <circle cx="8.5" cy="8.5" r="5.5"/>
                    <line x1="13" y1="13" x2="18" y2="18"/>
                </svg>
                <input
                    className="crl-search-input"
                    type="text"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Rechercher…"
                />
                {search && (
                    <button className="crl-search-clear" onClick={() => setSearch('')}>✕</button>
                )}
            </div>

            {filteredItems.length === 0 && (
                <p className="crl-empty">Aucune option disponible</p>
            )}

            <ul className="crl-list">
                {filteredItems.map((item) => {
                    const checked = isChecked(item);
                    return (
                        <li key={item.value} className="crl-item">
                            <label className={`crl-label ${
                                (mode === 'exclure' && checked) || mode === 'nappartient_pas'
                                    ? 'crl-label--not'
                                    : ''
                            }`}>
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={() => handleCheck(item)}
                                    className={`crl-checkbox crl-checkbox--${mode}`}
                                />
                                <span className="crl-text">
                                    {Array.isArray(item.label) ? item.label.join("/") : item.label}
                                </span>
                                <span className="crl-count">({item.count})</span>
                            </label>
                        </li>
                    );
                })}
            </ul>

            {hasActiveFilter && (
                <div className="crl-actions">
                    <button className="crl-action-btn crl-clear" onClick={handleClearAll}>
                        Tout effacer
                    </button>
                </div>
            )}
        </div>
    );
};

export default CustomRefinementList;